import { notify } from '@affine/component';
import { ModalHeader } from '@affine/component/auth-components';
import { OAuth } from '@affine/core/components/affine/auth/oauth';
import { AuthService, FetchService } from '@affine/core/modules/cloud';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService, WorkspacesService } from '@toeverything/infra';
import { cssVar } from '@toeverything/theme';
import { Button as AntdButton, Card, Divider, Flex, Form as AntdForm, Spin } from 'antd';
import { type Dispatch, type SetStateAction, useState, useEffect } from 'react';
import { track } from '@affine/track';
import type { SignInState } from '.';
import * as style from './style.css';
import { FAntdInput } from 'izid'
import { buildShowcaseWorkspace } from "@affine/core/utils/first-app-data";

export const SignInStep = ({
  state,
  close,
}: {
  state: SignInState;
  changeState: Dispatch<SetStateAction<SignInState>>;
  close: () => void;
}) => {
  const t = useI18n();
  const authService = useService(AuthService);
  const fetchService = useService(FetchService);
  const workspacesService = useService(WorkspacesService);
  const loginStatus = useLiveData(authService.session.status$);

  useEffect(() => {
    if (loginStatus === 'authenticated') {
      close();
      // notify.success({
      //   title: t['com.affine.auth.toast.title.signed-in'](),
      //   message: t['com.affine.auth.toast.message.signed-in'](),
      // });
    }
  }, [ close, loginStatus]);

  // useEffect(() => {
  //   // TODO 添加延迟时间，防止频繁刷新，线上确定没有问题后可以删除延迟
  //   setTimeout(() => {
  //     const oauthUrl = process.env.FPROD_OTHER_URL + `/oauth/login?provider=OSREDM`;
  //     track.$.$.auth.signIn({ method: 'oauth', provider: 'OSREDM' });
  //     window.location.href = oauthUrl
  //   }, 1000)
  // }, []);

  // 注册状态
  const [ isRegisterStatus, setIsRegisterStatus ] = useState(false);

  // 前往注册
  const changeFormStatus = isRegister => {
    form.resetFields();
    setIsRegisterStatus(isRegister)
  }

  const createWorkspace = async (name: string, workspaceFlavour: string) => {
    track.$.$.$.createWorkspace({ flavour: workspaceFlavour });
    // this will be the last step for web for now
    // fix me later
    await buildShowcaseWorkspace(
      workspacesService,
      workspaceFlavour,
      name
    );
  }

  // 登录、注册
  const [ form ] = AntdForm.useForm()
  const [ formLoading, setFormLoading ] = useState(false);
  const submitForm = () => {
    form.validateFields().then(async () => {
      const formData = form.getFieldsValue();
      setFormLoading(true)
      if (isRegisterStatus) {
        //  注册
        const { registered } = await authService.checkUserByEmail(formData.email);
        if (registered) {
          notify.warning({
            title: '此账号已被注册.',
          });
          return setFormLoading(false)
        }
        // 注册rag系统
        fetchService.fetch(process.env.FPROD_OTHER_URL+'/v1/user/affine/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: formData.email,
            newpassword: formData.password,
            password: formData.password,
            nickname: formData.username ?? formData.email.split('@')[0],
          })
        }).catch(e => e)
        // 注册本系统
        try {
          const createNewUser = await fetchService.fetch('/api/auth/create-user', {
            method: 'POST',
            body: JSON.stringify({
              email: formData.email,
              name: formData.username ?? formData.email.split('@')[0],
              password: formData.password,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          });
          if (createNewUser.status === 201) {
            // 重定向到工作区页面
            notify.success({
              title: '注册成功，自动登录中...',
            });
            setTimeout(() => {
              authService.signInPassword({
                email: formData.email,
                password: formData.password,
              }).catch(e => e).finally(() => {
                createWorkspace('默认工作区', 'affine-cloud')
                setFormLoading(false)
              })
            }, 1000)
          } else {
            notify.warning({
              title: '注册失败，请联系管理员.',
            });
          }
        } catch (e) {

        }

      } else {
        // 登录
        authService.signInPassword({
          email: formData.email,
          password: formData.password,
        }).catch(e => e).finally(() => {
          setFormLoading(false)
        })
      }
    }).catch(e => e)
  }


  // return (
  //   <div
  //     style={ {
  //       display: 'flex',
  //       alignItems: 'center',
  //       justifyContent: 'center',
  //       flexDirection: 'column',
  //     } }
  //   >
  //     <Spin size="large" />
  //     <div
  //       style={ {
  //         marginTop: 16,
  //         fontSize: 16,
  //         color: '#666',
  //         letterSpacing: '0.5px'
  //       } }
  //     >
  //       正在自动登录理论在线群智创新子系统...
  //     </div>
  //   </div>
  // )


  return <div style={ { marginTop: '50px' } }>
    <Card style={ { padding: '30px', width: '500px', borderRadius: '30px' } }>
      <div style={ { marginBottom: '30px' } }>
        <ModalHeader
          title={ isRegisterStatus ? '注册' : '登录' }
          subTitle={
            isRegisterStatus ? '开启您的专属旅程' : '理论在线群智创新子系统'
          }
        />
      </div>
      <Spin spinning={ formLoading }>
        <AntdForm
          form={ form }
          layout={ "vertical" }
          size={ 'large' }
        >
          {
            isRegisterStatus &&
            <AntdForm.Item
              name={ 'username' }
              label={ <label className={ style.inputLabel }>账号名称</label> }
              rules={ [
                {
                  max: 10,
                  message: '账号名称不能超过十个字符'
                },
              ] }
            >
              <FAntdInput placeholder={ '请输入账号名称' } />
            </AntdForm.Item>
          }
          <AntdForm.Item
            name={ 'email' } rules={ [
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) return Promise.reject('请输入有效的邮箱地址');
                return Promise.resolve();
              }
            },
            {
              required: true,
              message: '邮箱地址不能为空'
            }
          ] }
            label={ <label className={ style.inputLabel }>电子邮箱</label> }
            validateTrigger="onBlur"
          >
            <FAntdInput placeholder={ '请输入邮箱地址' } />
          </AntdForm.Item>
          <AntdForm.Item
            name={ 'password' }
            label={ <label className={ style.inputLabel }>密码</label> }
            validateTrigger="onBlur"
            rules={ [
              {
                required: true,
                message: '密码不能为空'
              },
              {
                validator: (_, value) => {
                  if (!value || !isRegisterStatus) return Promise.resolve();
                  const regex = /^.{8,16}$/;
                  if (!regex.test(value)) return Promise.reject('密码长度为8-16位');
                  return Promise.resolve();
                }
              }
            ] }
          >
            <FAntdInput.Password onBlur={ () => {
              const againPassword = form.getFieldValue('againPassword')
              if (againPassword) form.validateFields([ 'againPassword' ])
            } } placeholder={ '请输入密码' } />
          </AntdForm.Item>
          {
            isRegisterStatus &&
            <AntdForm.Item
              name={ 'againPassword' }
              validateTrigger="onBlur"
              label={ <label className={ style.inputLabel }>确认密码</label> }
              rules={ [
                {
                  required: true,
                  message: '请再次输入密码'
                },
                ({ getFieldValue }) => ({
                  validator: (_, value) => {
                    if (!value) return Promise.resolve();
                    const password = getFieldValue('password')
                    if (password !== value) return Promise.reject('两次输入的密码不一致');
                    return Promise.resolve();
                  }
                })
              ] }
            >
              <FAntdInput.Password placeholder={ '请再次输入密码' } />
            </AntdForm.Item>
          }
          <AntdForm.Item noStyle>
            <Flex
              justify={ 'flex-end' }
              style={ { margin: '-5px 0 15px 0' } }
            >
              { isRegisterStatus ? (
                <AntdButton type={ 'link' } onClick={ () => changeFormStatus(false) }>
                  已有账号？前往登录
                </AntdButton>
              ) : (
                <AntdButton type={ 'link' } onClick={ () => changeFormStatus(true) }>
                  没有账号？前往注册
                </AntdButton>
              ) }
            </Flex>
          </AntdForm.Item>
          <AntdButton style={ { background: '#2b59ff' } } type={ 'primary' } block onClick={ submitForm }>
            { isRegisterStatus ? '立即注册' : '立即登录' }
          </AntdButton>
        </AntdForm>

        {
          !isRegisterStatus &&
          <div style={ { marginTop: '80px' } }>
            <Divider
              style={ { color: cssVar('textSecondaryColor'), borderColor: '#d4d4d4' } }>或使用以下方式登录</Divider>
            <OAuth redirectUrl={ state.redirectUrl } />
          </div>
        }
      </Spin>
    </Card>
  </div>
}
